import * as React from "react";

import CategoryPage, { CategoryPageProps } from "./CategoryPage";

function SourceCategoryPage(
  props: Omit<CategoryPageProps, "searchCategoryType" | "title" | "subtitle">,
) {
  return (
    <CategoryPage
      title="Search procurement activity by issuing source"
      subtitle="Browse all government procurement activity by issuing source below."
      searchCategoryType="source"
      {...props}
    />
  );
}

export default SourceCategoryPage;
